import { FC, memo, ReactNode } from "react"

import * as RTooltip from "@radix-ui/react-tooltip"
import clsx from "clsx"

import { LabelSmall } from "@/components/TypeRamp"

type TooltipProps = {
  children: ReactNode
  tip: ReactNode
} & RTooltip.TooltipContentProps
export const Tooltip: FC<TooltipProps> = ({ children, tip, ...props }) => {
  return (
    <RTooltip.Provider>
      <RTooltip.Root>
        <RTooltip.Trigger asChild>{children}</RTooltip.Trigger>
        <RTooltip.Portal>
          <RTooltip.Content
            sideOffset={7}
            className={clsx(
              "bg-slate z-50 rounded-sm border border-black px-1.5 py-1 text-white",
              LabelSmall.classNames
            )}
            side="bottom"
            aria-hidden="true"
            {...props}
          >
            {tip}
          </RTooltip.Content>
        </RTooltip.Portal>
      </RTooltip.Root>
    </RTooltip.Provider>
  )
}
export default memo(Tooltip)
